import home from "./home"; // 首页
// import userInfo from "./userInfo"; // 用户信息

import trade from "./trade";
import productDetail from "./productDetail"; // 商品详情
import userCenter from "./userCenter"; // 用户中心
import offer from "./offer"; // 出价
import login from "./login"; // login
import look from "./look"; // 看货相关

const router = [
  ...home,
  ...productDetail,
  ...userCenter,
  ...offer,
  // ...login,
  ...look,
  ...trade,
];
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js